import { HashRouter } from "react-router-dom";
import CrudApi from "./components/Crud/crudApi";
import { CrudProvider } from "./context/crudContext";
import { FilterProvider } from "./context/filterContext";
import { FormProvider } from "./context/formContext";

function App() {
  return (
    <HashRouter>
      <FilterProvider>
        <FormProvider>
          <CrudProvider>
            <CrudApi />;
          </CrudProvider>
        </FormProvider>
      </FilterProvider>
    </HashRouter>
  );
}

export default App;
